export default {
    namespaced: true,
    state: {

    },
    mutation: {

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js